export const NOT_SUPPORTED_ERROR: string = 'NotSupportedError';

export const ERRORS = {
  PermissionDismissedError: `
    We can't seem to detect a camera and a microphone.
    Try connecting a webcam or a microphone to join the conversation.
    If the problem continues, please clear your cookies, close all browser windows and try again.
  `,

  PermissionDeniedError: `
    The browser is blocking your camera and microphone.
    To enter the the video conversation, please refresh the page and allow Pramp access to your audio/video.
    If the problem continues, please clear your cookies, close all browser windows and try again.
  `,

  NotAllowedError: `
    We couldn't find any devices, please make sure they are connected and that you've approved access.
    If the problem continues, please clear your cookies, close all browser windows and try again.
  `,

  NotReadableError: `
    We can't seem to detect a camera and a microphone.
    please make sure they are connected and that you've approved access.
    If the problem continues, please clear your cookies, close all browser windows and try again.
  `,

  [NOT_SUPPORTED_ERROR]: `
    WebRTC is not supported by this browser
  `,
};
